import React, { useCallback, useEffect, useRef, useState } from "react";
import { getPioSolverData } from "./api/getPioSolverData";
import { Preloader } from "../../components/Preloader";
import { TextArea } from "./components/TextArea";
import "./PioSolver.scss";
import { getSmartVideoHTML } from "../Cards/components/Class/utils";

export const PioSolver = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [activeContent, setActiveContent] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  let tooltipTimeoutId = useRef();
  const sections = data[activeTab]?.data || [];

  const getData = useCallback(async () => {
    setIsLoading(true);
    const data = await getPioSolverData();
    setData(data);
    setIsLoading(false);
  }, [setData, setIsLoading]);

  useEffect(() => {
    getData();
  }, [getData]);

  const onButtonClick = useCallback(
    async (content) => {
      setActiveContent(content);
      await navigator.clipboard.writeText(content.content);
      setShowTooltip(true);
      tooltipTimeoutId.current && clearTimeout(tooltipTimeoutId.current);
      tooltipTimeoutId.current = setTimeout(() => {
        setShowTooltip(false);
      }, 1500);
    },
    [setActiveContent, setShowTooltip, tooltipTimeoutId]
  );

  const renderContent = () => {
    if (activeTab === "video") {
      return (
        <div className="PioSolver__video">
          <div
            dangerouslySetInnerHTML={{
              __html: getSmartVideoHTML(
                "https://jlsecrets.s3.amazonaws.com/ATC/PioSolver-Starter-Pack-Tutorial.mp4"
              ),
            }}
          />
        </div>
      );
    }
    return (
      <div className="PioSolver__box">
        <div className="PioSolver__section">
          {sections.map((section) => {
            const { section_title: sectionTitle, buttons } = section;
            return (
              <div className="PioSolver__section-item">
                <p className="PioSolver__section-title">{sectionTitle}</p>
                <div className="PioSolver__section-buttons">
                  {buttons.map((button) => {
                    const { title, content, sub_title: subtitle } = button;
                    return (
                      <button
                        onClick={async () => {                          
                          // actid=28
                          window.analytics?.track("button:click", {
                            "button_name": title,
                            "parent_object_title": sectionTitle,
                            "title": title,
                            "url": window.location.href
                          });

                          onButtonClick(content);
                        }}
                        className="PioSolver__section-button"
                      >
                        <div> {title}</div>
                        {subtitle && (
                          <div className="PioSolver__section-button-subtitle">
                            {subtitle}
                          </div>
                        )}
                      </button>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
        <TextArea content={activeContent} showTooltip={showTooltip} />
      </div>
    );
  };

  return (
    <div className="PioSolver">
      {isLoading ? (
        <Preloader />
      ) : (
        <div>
          <div className="PioSolver__top">
            <h1 className="PioSolver__top-title">PioSolver Starter Pack</h1>
            <p className="PioSolver__top-subtitle">
              Click on a Preset button below to copy the preset to your
              clipboard. Then paste it into PioSOLVER to run the sim!
            </p>
          </div>
          <div className="PioSolver__tabs">
            {data.map((item, idx) => {
              const { tab_title: tabTitle } = item;
              const isActive = idx === activeTab;
              return (
                <div
                  style={{
                    color: isActive && "#0084FF",
                    fontWeight: isActive ? "bold" : "normal",
                  }}
                  className="PioSolver__tabs-button"
                  onClick={() => {
                    // actid=27
                    window.analytics?.track("tab:click", {
                      "parent_object_title": "PioSolver Starter Pack",
                      "tab_name": tabTitle
                    });

                    setActiveTab(idx);
                  }}
                >
                  {tabTitle}
                </div>
              );
            })}
            <div
              style={{
                color: activeTab === "video" && "#0084FF",
                fontWeight: activeTab === "video" ? "bold" : "normal",
              }}
              className="PioSolver__tabs-button"
              onClick={() => {
                // actid=27
                window.analytics?.track("tab:click", {
                  "parent_object_title": "PioSolver Starter Pack",
                  "tab_name": "Tutorial"
                });

                setActiveTab("video");
              }}
            >
              Tutorial
            </div>
          </div>
          {renderContent()}
        </div>
      )}
    </div>
  );
};
